import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import View from './business-pop-mail.presenter';
import {
  API_INITIATE_BUSINESS_POP_MAIL_ENDPOINT,
  API_COMPLETE_BUSINESS_POP_MAIL_CUSTOMER_DATA_ENDPOINT,
  API_COMPLETE_SUBMIT_BUSINESS_POP_MAIL,
  API_INITIATE_SUBMIT_BUSINESS_POP_MAIL,
} from '../../app-constants';
import { submitBusinessPopMail } from './business-pop-mail.actions';

// Reducer
export const businessPopMailReducer = (state = {
  loading: false,
  data: {},
  dataLoaded: false,
  formSubmitted: false,
  enableNoAction: false,
}, action) => {
  switch (action.type) {
    case API_INITIATE_BUSINESS_POP_MAIL_ENDPOINT: {
      return state;
    }
    case API_COMPLETE_BUSINESS_POP_MAIL_CUSTOMER_DATA_ENDPOINT: {
      return {
        ...state,
        loading: false,
        data: action.data,
        dataLoaded: true,
        formSubmitted: false,
      };
    }
    case API_INITIATE_SUBMIT_BUSINESS_POP_MAIL: {
      return {
        ...state,
        loading: false,
        dataLoaded: false,
        formSubmitted: false,
      };
    }
    case API_COMPLETE_SUBMIT_BUSINESS_POP_MAIL: {
      return {
        ...state,
        loading: false,
        dataLoaded: false,
        formSubmitted: true,
      };
    }
    default:
      return state;
  }
};

// Map & Connect
export const mapStateToProps = state => ({
  authorableContent: state.authorableContentReducer.authorableContent,
  dataLoaded: state.businessPopMailReducer.dataLoaded,
  customerData: state.businessPopMailReducer.data,
  formSubmitted: state.businessPopMailReducer.formSubmitted,
  userSubmitted: state.businessPopMailReducer.data.userSubmitted,
  enableNoAction: state.businessPopMailReducer.data.noAction,
});

export const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    submitBusinessPopMail,
  }, dispatch),
});

const BusinessPopMail = connect(
  mapStateToProps,
  mapDispatchToProps,
)(View);

export default BusinessPopMail;
